export default "__VITE_ASSET__ff8999b8__"